import clsx from 'clsx';
import { Loader } from '@spotted-zebra-uk/ui-components';
import styles from './Layout.module.scss';

export default function Layout({
  children,
  loading,
}: {
  children?: React.ReactNode;
  loading?: boolean;
}) {
  return (
    <div className={clsx(styles.container, loading && styles.loading)}>
      {loading ? <Loader variant="bubbles" /> : children}
    </div>
  );
}
